var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10084_163375)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79184 7.92876L13 12.1369L17.2082 7.92875C17.4465 7.69042 17.8329 7.69042 18.0713 7.92875C18.3096 8.16707 18.3096 8.55351 18.0713 8.79184L13.8631 13L18.0712 17.2082C18.3096 17.4465 18.3096 17.8329 18.0712 18.0713C17.8329 18.3096 17.4465 18.3096 17.2082 18.0713L13 13.8631L8.79184 18.0713C8.55351 18.3096 8.16709 18.3096 7.92876 18.0713C7.69043 17.8329 7.69043 17.4465 7.92876 17.2082L12.1369 13L7.92875 8.79185C7.69042 8.55352 7.69042 8.16709 7.92875 7.92876C8.16707 7.69043 8.55351 7.69043 8.79184 7.92876Z",
    fill: "#EE4F4F"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    stroke: "#E5E7DF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10084_163375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatClose);
export default __webpack_public_path__ + "static/media/chat-close.c3ea7a147b5453b64effef285c26afc8.svg";
export { ForwardRef as ReactComponent };